export const COLORS = {
  alliance_blue: "#27568A",
};
